import comparable from "apis/comparable";
import { WebApiRequest, HTTP_GET } from "../../tools/webservice";

export const validateComparables = (controlNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: comparable.validateComparables(controlNumber),
  successCallback,
  mountedRef,
});

export const validateComparablesPhoenix = (controlNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: comparable.validateComparablesPhoenix(controlNumber),
  successCallback,
  mountedRef,
});

export const getSsoUrl = (controlNumber, vendor, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: comparable.getSsoUrl(controlNumber, vendor),
  successCallback,
  mountedRef,
});

export const getPropmixSso = (controlNumber, successCallback, mountedRef) => getSsoUrl(controlNumber, "propmix", successCallback, mountedRef);
